import React, { useEffect, useState, useRef } from "react";
import { getMessages, postMessage } from "@/lib/api";
import { PageHeader } from "@/components/dashboard/ui";
import { Send, Paperclip } from "lucide-react";
import { toast } from "sonner";

export default function Messages() {
  const [messages, setMessages] = useState([]);
  const [msg, setMsg] = useState("");
  const end = useRef(null);
  useEffect(() => { getMessages().then(setMessages); }, []);
  useEffect(() => { end.current?.scrollIntoView({ behavior: "smooth" }); }, [messages]);
  const send = async () => {
    if (!msg.trim()) return; const text = msg; setMsg("");
    try { const m = await postMessage({ text }); setMessages((p) => [...p, m]); } catch { toast.error("Send failed"); }
  };
  return (
    <div className="fade-in max-w-3xl">
      <PageHeader title="Care Team Chat" subtitle="Secure messaging for Noah Smith's care circle" />
      <div className="card-soft p-5 flex flex-col" style={{ height: "70vh" }}>
        <div className="flex-1 overflow-y-auto thin-scroll space-y-4 pr-1">
          {messages.map((m) => (
            <div key={m.id} className={`flex gap-3 ${m.self ? "flex-row-reverse text-right" : ""}`}>
              <img src={m.avatar} alt={m.author} className="h-9 w-9 rounded-full object-cover shrink-0" />
              <div>
                <div className={`flex items-center gap-2 ${m.self ? "justify-end" : ""}`}><span className="text-[13px] font-bold text-[#10233f]">{m.author}</span><span className="text-[11px] text-slate-400">{m.role}</span><span className="text-[11px] text-slate-300">{m.time}</span></div>
                <div className={`mt-1 text-[14px] rounded-2xl px-4 py-2.5 inline-block ${m.self ? "bg-[#1a5fd0] text-white" : "bg-[#f2f6fc] text-[#33425c]"}`}>{m.text}</div>
                {m.reactions?.length > 0 && <div className={`mt-1 flex gap-1 ${m.self ? "justify-end" : ""}`}>{m.reactions.map((r, i) => <span key={i} className="text-[12px] bg-white border border-slate-100 rounded-full px-2 py-0.5">{r.emoji} {r.count}</span>)}</div>}
              </div>
            </div>
          ))}
          <div ref={end} />
        </div>
        <div className="mt-4 flex items-center gap-2 bg-[#f2f6fc] rounded-full px-4 py-2">
          <input data-testid="messages-input" value={msg} onChange={(e) => setMsg(e.target.value)} onKeyDown={(e) => e.key === "Enter" && send()} placeholder="Type a message…" className="flex-1 bg-transparent outline-none text-[14.5px]" />
          <button className="text-slate-400"><Paperclip size={18} /></button>
          <button data-testid="messages-send" onClick={send} className="h-9 w-9 rounded-full btn-primary grid place-items-center"><Send size={16} /></button>
        </div>
      </div>
    </div>
  );
}
